

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const UPADATEEMPLOYEE= createAsyncThunk(
  "updateEmployee/updateEmployee",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateEmployeeSlice = createSlice({
  name: "updateEmployeeSlice",
  initialState: {
    updateEmployee: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateEmployee: (state) => {
        state.updateEmployee.loading = false
        state.updateEmployee.error = false
        state.updateEmployee.data = []
        state.updateEmployee.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPADATEEMPLOYEE.fulfilled, (state, action) => {
      state.updateEmployee = {
        ...state.updateEmployee,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPADATEEMPLOYEE.pending, (state, action) => {
      state.updateEmployee = {
        ...state.updateEmployee,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPADATEEMPLOYEE.rejected, (state, action) => {
      state.updateEmployee = {
        ...state.updateEmployee,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateEmployeeAction = {
    UPADATEEMPLOYEE,
};

export { updateEmployeeAction };
export default updateEmployeeSlice.reducer;
export const {setInitialStateOfupdateEmployee} = updateEmployeeSlice.actions
